import { SectionHeader } from "./Home";

const SECTIONS = [
  ["1. Before Work Begins", "If you cancel a request before our researchers begin records retrieval, you receive a full refund less payment-gateway charges (if any). Cancellations can be made by phone or email quoting your reference number (TT-XXXXXXXX)."],
  ["2. After Retrieval Has Started", "Once field retrieval or portal searches have commenced, a partial refund of up to 50% of the fee applies, reflecting work already performed and government fees already paid (which are non-recoverable)."],
  ["3. After Report Delivery", "No refund is payable once the report, Terraa Score, or requested records have been delivered. If you believe a report contains an error attributable to us, notify us within 7 days — we will re-examine the records and issue a corrected report at no cost."],
  ["4. Urgent Track Requests", "Urgent (24–72 hour) engagements are prioritised immediately and are non-refundable once accepted."],
  ["5. Our Inability to Deliver", "If we cannot complete an engagement — for example, records are unavailable in the jurisdiction, or we decline the assignment after review — you receive a full refund of unearned fees within 7 business days."],
  ["6. Government Fees and Third-Party Charges", "Statutory fees paid to government portals, sub-registrar offices, or for certified/digitally signed copies are collected at cost and are non-refundable once incurred."],
  ["7. Processing Timelines", "Approved refunds are processed to the original payment method within 7–10 business days. We will confirm by email when the refund is initiated."],
  ["8. How to Request a Refund", "Email terraaandtitle@gmail.com with your reference number, registered contact details, and reason for the request. Our team responds within 2 business days."],
];

export default function RefundPolicyPage() {
  return (
    <div data-testid="refund-policy-page">
      <section className="py-24 md:py-32 bg-white">
        <div className="max-w-4xl mx-auto px-6 lg:px-10">
          <SectionHeader eyebrow="Legal" title="Refund Policy" sub="Last updated: June 2026" className="mb-14" />
          <div className="space-y-10">
            {SECTIONS.map(([h, body]) => (
              <div key={h}>
                <h2 className="font-heading !font-['Poppins'] text-lg font-medium text-[#113835]">{h}</h2>
                <p className="mt-3 text-sm text-gray-600 font-light leading-relaxed">{body}</p>
              </div>
            ))}
            <p className="text-sm text-gray-500 font-light border-t border-[#113835]/10 pt-8">
              This policy forms part of our Terms of Use. For assistance call +91 84249 33337.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
}
